import React from 'react';
import PropTypes from 'prop-types';

import { Column, Row, gridCalculator } from 'moet-core';

import HeaderCell from './HeaderCell';
import HeaderGutter from './HeaderGutter';

const HeaderRow = ({ cells, widths = [] }) => {
  return (
    <Row>
      {cells.map((val, index) => {
        const isFirst = index === 0;
        const columnWidth =
          widths.length !== 0 ? widths[index] : gridCalculator.MAX_NUMBER_OF_COLUMNS / cells.length;

        return (
          <React.Fragment key={index}>
            {!isFirst && <HeaderGutter />}
            <Column numberOfColumns={columnWidth}>
              <HeaderCell>{val}</HeaderCell>
            </Column>
          </React.Fragment>
        );
      })}
    </Row>
  );
};

HeaderRow.propTypes = {
  cells: PropTypes.array.isRequired,
  widths: PropTypes.array,
};

export default HeaderRow;
